import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Slugify a label into a stable id. Mirrors the migration script's slug logic
 * so admin-edited categories produce the same `categoryId` as imported data.
 */
export function slugify(s: string): string {
  return (
    String(s || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 80) || 'uncategorized'
  );
}
